/** @format */

import React from "react";
import {
	DropdownItem,
	DropdownMenu,
	Row,
	Container,
	Col,
	Dropdown,
	DropdownToggle,
	Nav,
	Navbar,
	NavbarBrand,
	NavbarToggler,
	Collapse,
	Badge,
	Form,
	Link,
	InputGroup,
	Input,
	Button,
	InputGroupAddon,
} from "reactstrap";

import {
	setCookie,
	getCookie,
	eraseCookie,
	setLocalStorage,
	getLocalStorage,
	getUrlParam,
} from "../global/browserFunctions";
import { showNotification } from "../global/notification";

import UseWindowSize from "../hooks/UseWindowSize";

//import menu from "../data/menu.json";

import Icon from "./Icon";
import "../../src/App.css";
import MainIcons from "./MainIcons";
import { category } from "../global/url";
import jquery from "jquery";
import Loader from "./Loader";

const Header = ({ header, history, searchquery, cartCount }) => {
	const [dropdown, setDropdown] = React.useState({}); //To show dropdown, only work when there is more than lvl2 menu
	const [collapse, setCollapse] = React.useState({}); //To toggle menu
	const [menu, setMenu] = React.useState([]);
	const [loading, setLoading] = React.useState(true);
	const [parentName, setParentName] = React.useState(false);
	const [viewportWidth, setViewportWidth] = React.useState(false);
	const [dropdownAnimate, setDropdownAnimate] = React.useState(false);
	const [query, setQuery] = React.useState(searchquery);
	let accountName = getCookie("name");

	React.useEffect(() => {
		setQuery(searchquery);
	}, [searchquery])

	const toggleDropdown = (name) => {
		// Set dropdown by name
		setDropdown({ ...dropdown, [name]: !dropdown[name] });
	};

	React.useEffect(() => {
		getmenu();
	}, []);

	const onChange = (e) => {
		const value = e.target.value
		setQuery(value)
	}

	const handleSubmit = (e) => {
		e.preventDefault();
		var searchQuery = query || "";
		if (searchQuery.trim().length < 3) {
			showNotification(
				"",
				"info",
				"Query needs to be atleast 3 characters"
			);
			return false;
		}

		if (searchQuery.indexOf("'") != -1) {
			showNotification(
				"",
				"info",
				"Do not include special character in your query"
			);
			return false;
		}
		history.push('/search?query=' + query)
		window.location.reload();
	}

	const getmenu = () => {

		var menuFromStorage = JSON.parse(getLocalStorage("menu")) || []; //To get, set menu from localstorgae
		if (menuFromStorage.length > 0) {
			setLoading(false);
			setMenu(menuFromStorage);
		} else {
			fetchmenu(); // if no menu found in localstorage, we fetch 
		}
	};

	const fetchmenu = () => { //function to fetch meny
		jquery
			.ajax({
				url: category + "&router=getmenu",
				dataType: "jsonp",
			})
			.done(function (data) {
				setLoading(false);
				data = JSON.parse(data);
				if (data[0].responseString == "Success") {
					var menu = data[0].responseMessage;
					menu = unescape(menu);
					menu = JSON.parse(menu);
					console.log(menu, 'menu')
					menu = menu.reverse()
					menu.push({ name: 'Support', link: '/support', level1: true })
					setLocalStorage("menu", JSON.stringify(menu));
					setMenu(menu);
				}
			});
	};

	const toggleCollapse = (name) => {
		// Set collapse by name
		setCollapse({ ...collapse, [name]: !collapse[name] });
	};
	const [scroll, setScroll] = React.useState(false);
	React.useEffect(() => {
		window.addEventListener("scroll", () => {
			setScroll(window.scrollY > 10);
		});
	}, []);

	var widthHook = UseWindowSize().width; // Viewport size hook

	React.useEffect(() => {
		setViewportWidth(widthHook); // Set viewport width on load
		// setCollapse(false) // Close collapse on viewport change
	}, [widthHook]);
	return (
		<div className={scroll ? "bg-Header-sticky" : "bg-Header"}>
			<Loader loading={loading} />
			<header
				className={`header ${header && header.absolute ? "header-absolute" : ""
					}`}
			>
				<Navbar
					expand='lg'
					light
					style={{ zIndex: "2" }}
					color={
						header && header.transparentNavbar
							? collapse.navbar
								? "white"
								: "transparent"
							: "white"
					}
					className={`border-0 ${header && header.transparentNavbar ? "shadow-0" : ""
						} px-lg-5 ${collapse.navbar ? "was-transparent was-navbar-light" : ""
						}`}
				>
					{/* LOGO */}
					<a href='/' className='logo-div'>
						<img src='/image.png'></img>
					</a>

					{/* END LOGO */}

					{/* TOP USER MOBILE ICONS */}
					<MainIcons className='d-block d-lg-none' />
					{/* TOP USER MOBILE ICONS */}

					{/* NAV MOBILE TOGGLER  */}
					<NavbarToggler
						className='navbar-toggler-right text-hover-primary'
						onClick={() => toggleCollapse("navbar")}
						aria-label='Toggle navigation'
					>
						<Icon icon='menu-hamburger-1' className='navbar-icon' />
					</NavbarToggler>
					{/* END NAV MOBILE TOGGLER */}

					{/* MENU */}
					<Collapse navbar isOpen={collapse.navbar}>
						<Nav className='mt-3 mt-lg-0' navbar tag='div'>
							{menu.map((item, index) => {
								// Mapping through menu items

								const itemId =
									item.name.split(" ").join("").toLowerCase() + "_" + index;

								return (
									<div key={itemId}>
										{item.level1 && (
											<a className='nav-link' href={item.link}>
												<b>{item.name}</b>
											</a>
										)}

										{!item.level1 && (
											<Dropdown
												key={item.name}
												className={item.megamenu ? "position-static" : ""}
												isOpen={dropdown[item.name]}
												toggle={() => toggleDropdown(item.name)}
												inNavbar
											>
												{/* DROPDOWN TOGGLE */}
												<DropdownToggle
													className={parentName === item.name ? "active" : ""}
													id={itemId}
													nav
													caret
													onClick={() =>
														setDropdownAnimate({
															...dropdownAnimate,
															[item.name]: !dropdown[item.name],
														})
													}
												>
													{item.name}
												</DropdownToggle>
												{/* END DROPDOWN TOGGLE */}

												{/* DROPDOWN MENU */}
												<DropdownMenu
													className={`${item.groups ? "py-0" : ""} ${item.icons ? "py-lg-0" : ""
														} ${item.megamenu ? "megamenu px-4 px-lg-5 py-lg-5" : ""
														} ${dropdownAnimate[item.name] === false ? "hide" : ""
														}`}
													aria-labelledby={itemId}
												>
													{/* SIMPLE MENU */}
													{item.links &&
														item.links.map((link, index) =>
															link.divider ? (
																// SIMPLE MENU DIVIDER
																link.name ? ( // If divider has name show header
																	<DropdownItem key={index} header>
																		{link.name}
																	</DropdownItem>
																) : (
																	// Else only line divider
																	<DropdownItem key={index} divider />
																)
															) : (
																// SIMPLE MENU LINK
																<a key={link.name} href={link.link}>
																	<DropdownItem onClick={() => item.name}>
																		{link.name}
																		{link.new && (
																			// IF NEW ITEM ADD BADGE
																			<Badge
																				color='primary-light'
																				className='ml-1'
																			>
																				New
																			</Badge>
																		)}
																	</DropdownItem>
																</a>
															)
														)}
													{/* END SIMPLE MENU */}
												</DropdownMenu>
												{/* END DROPDOWN MENU */}
											</Dropdown>
										)}
									</div>
								);
							})}
						</Nav>

						{/* SEARCH BLOCK */}
						<Form className='d-lg-flex ml-auto mr-lg-5 mr-xl-6 my-4 my-lg-0' onSubmit={handleSubmit}>
							<InputGroup className='input-group-underlined'>
								<Input
									type='text'
									placeholder='Search'
									name='query'
									aria-label='Search'
									className='form-control-underlined pl-3'
									value={query}
									onChange={(e) => onChange(e)}
								/>
								<InputGroupAddon addonType='append' className='ml-0'>
									<Button color='underlined'>
										<Icon className='navbar-icon' icon='search-1' />
									</Button>
								</InputGroupAddon>
							</InputGroup>
						</Form>
						{/* TOP USER ICONS */}
						<MainIcons
							className='d-none d-lg-block'
							sidebarRight
							history={history}
							accountName={accountName}
							cartCount={cartCount}
						/>

						{/* END TOP USER ICONS */}
					</Collapse>
					{/* END MENU */}
				</Navbar>
				{/* END NAV BAR */}
			</header>
		</div>
	);
};

export default Header;
